import moment from "moment";
import { useState, useEffect } from "react";
import { DateFormat } from "Utils/Constants";

import { getChildData, cloneDeepLimited } from "./utils";

const useForm = (initialValues) => {
  const [formValues, setFormValues] = useState(initialValues);

  useEffect(() => {
    setFormValues(initialValues);
  }, [initialValues]);

  return [
    formValues,
    ({ target }) => {
      const { name, value, checked, type } = target;
      const isCheckbox = type === "checkbox";

      setFormValues((data) => {
        const dataClone = cloneDeepLimited(data);
        const keys = name.split("."); // 'a.b.c' => ['a', 'b', 'c'] | 'a' => ['a']
        const nestedSegments = keys.slice(0, -1); // ['a', 'b'] | []
        const [finalSegment] = keys.slice(-1); // 'c' | 'a'
        const finalData = nestedSegments.reduce(getChildData, dataClone);
        if (typeof value?.getMonth === "function") {
          // Format date values to string
          finalData[finalSegment] = moment(value).format(DateFormat);
        } else if (isCheckbox) {
          finalData[finalSegment] = checked;
        } else {
          finalData[finalSegment] = value;
        }
        return dataClone;
      });
    },
  ];
};

export default useForm;
